import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-info">
          <p className="about-link-wrapper">
            <Link to="/about" className="about-link">
              아카데미 소개
            </Link>
          </p>
          <p className="address">경북 영천시 북안면 대원당길 111</p>
          <p className="contact">☎ 010-8577-1227</p>
          <p className="email">E메일 - freude103801@hanmail.net</p>
        </div>
        <div className="footer-copyright">
          <p>© 2024 dabia.net. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
